import { jsx } from '@emotion/core';
import { hasOwnProp } from '../../../../utils';
import { IconContainer, IconContainerWithBorder } from '../../../Common';
import { BanamexLogo, BancoAztecaLogo, BanorteLogo, BBVALogo, HSBCLogo, InbursaLogo, ItauLogo, SantarderLogo } from './Logos';
export var BANK_NAME_MAP = {
  BANAMEX: BanamexLogo,
  BANCOAZTECA: BancoAztecaLogo,
  BANORTE: BanorteLogo,
  BBVA: BBVALogo,
  HSBC: HSBCLogo,
  INBURSA: InbursaLogo,
  ITAU: ItauLogo,
  SANTANDER: SantarderLogo
};
export var BankLogo = _ref => {
  var {
    bankName,
    image: {
      url,
      rank
    } = {},
    styleOverrides
  } = _ref;

  if (!hasOwnProp(BANK_NAME_MAP, bankName) && !url) {
    return null;
  }

  if (url) {
    return jsx(IconContainerWithBorder, {
      css: styleOverrides,
      rank: rank
    }, jsx("img", {
      alt: bankName,
      "data-testid": "bank-logo-".concat(bankName),
      src: url
    }));
  }

  var CardArtComponent = BANK_NAME_MAP[bankName];
  return jsx(IconContainer, {
    css: styleOverrides
  }, jsx(CardArtComponent, null));
};
BankLogo.defaultProps = {
  isLeft: false,
  styleOverrides: ''
};